module.exports = __webpack_public_path__ + "static/media/a86.ccde9655.jpg";